import { createReducer, on } from '@ngrx/store';
import * as ServiceRegistrationsActions from './service-registrations.actions';
import { initialServiceRegistrationsState } from './service-registrations.state';
import { IServiceRegistration } from "../../../shared/model/service-registration.model";

export const serviceRegistrationsReducer = createReducer(
  initialServiceRegistrationsState,

  on(ServiceRegistrationsActions.findServiceRegistrations, (state, { searchFilter }) => ({
    ...state,
    loading: true,
    error: null,
    searchFilter
  })),

  on(ServiceRegistrationsActions.findServiceRegistrationsSuccess, (state, { registrations, opportunityIds }) => ({
    ...state,
    registrations,
    opportunityIds,
    loading: false,
    error: null
  })),

  on(ServiceRegistrationsActions.findServiceRegistrationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  on(ServiceRegistrationsActions.updateServiceRegistrationsSuccess, (state, { registrations }) => ({
    ...state,
    registrations: state.registrations.map((registration: IServiceRegistration): IServiceRegistration =>
      registrations.find((updated: IServiceRegistration): boolean => updated.id === registration.id) || registration)
  })),

  on(ServiceRegistrationsActions.updateServiceRegistrationsFailure, (state, { error }) => ({
    ...state,
    error
  })),

  on(ServiceRegistrationsActions.updateServiceRegistrationWithSupervisorSuccess, (state, { registration }) => ({
    ...state,
    registrations: state.registrations.map(r =>
      r.id === registration.id ? registration : r
    ),
    error: null
  })),

  on(ServiceRegistrationsActions.updateServiceRegistrationWithSupervisorFailure, (state, { error }) => ({
    ...state,
    error
  })),

);
